export const HOME_PAGE_KEY = 'home-page-key';

export const PATHS = {
  HOME_PAGE: '/home',
};
